// Schema: MbmProject. There is deliberately no delete: timesheet entries reference a project by
// its ItemId, so a project is deactivated (Status) instead of removed.
export const INSERT_MBM_PROJECT_MUTATION = `
  mutation InsertMbmProject($input: MbmProjectInsertInput!) {
    insertMbmProject(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_MBM_PROJECT_MUTATION = `
  mutation UpdateMbmProject($filter: String!, $input: MbmProjectUpdateInput!) {
    updateMbmProject(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;
